import { render, staticRenderFns } from "./RegisterCompany.vue?vue&type=template&id=8c31f56a&scoped=true&"
import script from "./RegisterCompany.vue?vue&type=script&lang=js&"
export * from "./RegisterCompany.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCompany.vue?vue&type=style&index=0&id=8c31f56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c31f56a",
  null
  
)

export default component.exports